module.exports = __webpack_public_path__ + "static/media/sildenafil.3523fa82.png";